import { JsonObject } from 'json2typescript';
import { FeeInterface } from '../interfaces/fee.interface';

@JsonObject('Fee')
export class Fee implements FeeInterface {
  CustodyFees: number;
  CustodyId: string;
  CustodyName: string;
  ImplicitFees: number;
  OtherFees: number;
  ServiceFees: number;

  constructor(obj?: any) {
    Object.assign(this, obj);
  }
}
